import { api } from '@~network/api';
import type { ITokenBank } from '@~types/types';

export function getTokenBank() {
  return api<null, ITokenBank>({ method: 'get', path: '/token-bank' });
}
